/*
import API from '../axios';
export const getServices = () => API.get('/service');
export const getServiceById = (id) => API.get(`/service/${id}`);
*/
import API from '../axios';

// Service API calls

// Get all services
export const getServices = () => API.get('/service');

// Get details of a single service by ID
export const getServiceById = (id) => API.get(`/service/${id}`);
